module.exports = __webpack_public_path__ + "img/DM.2cb382c3.svg";